import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { WhatYouWillFind } from './components/WhatYouWillFind';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { Benefits } from './components/Benefits';
import { Bonuses } from './components/Bonuses';
import { ImportantThings } from './components/ImportantThings';
import { WhereToStart } from './components/WhereToStart';
import { WhyWeCreated } from './components/WhyWeCreated';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { CountdownTimer } from './components/CountdownTimer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    const pageTitle = 'Primeros Bocados — 30 Recetas Esenciales para Bebés de 6 a 12 Meses';
    const desc = 'Guía digital con 30 recetas fáciles y nutritivas para iniciar la alimentación complementaria de tu bebé con calma, seguridad y confianza.';
    const ogTitle = 'Primeros Bocados — 30 Recetas Esenciales';
    // IMPORTANTE: Reemplaza esta URL con una imagen alojada en tu Shopify CDN o hosting permanente
    const coverImage = 'https://cdn.shopify.com/s/files/1/0000/0000/0000/files/primeros-bocados-cover.png';
    document.title = pageTitle;
    const setMeta = (attr: string, key: string, content: string) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    // Override any <title> tag in the head
    let titleEl = document.querySelector('title');
    if (!titleEl) {
      titleEl = document.createElement('title');
      document.head.appendChild(titleEl);
    }
    titleEl.textContent = pageTitle;
    // Meta description
    setMeta('name', 'description', desc);
    // Open Graph (Facebook, Instagram, WhatsApp)
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:url', 'https://primerosbocados.epikkastore.com/');
    setMeta('property', 'og:title', ogTitle);
    setMeta('property', 'og:description', desc);
    setMeta('property', 'og:image', coverImage);
    setMeta('property', 'og:image:alt', 'Portada del ebook Primeros Bocados');
    // Twitter
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', ogTitle);
    setMeta('name', 'twitter:description', desc);
    setMeta('name', 'twitter:image', coverImage);
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-mauve/30 pt-10" data-id="element-0">
      <CountdownTimer data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <WhatYouWillFind data-id="element-4" />
        <WhoIsThisFor data-id="element-5" />
        <Benefits data-id="element-6" />
        <Bonuses data-id="element-7" />
        <ImportantThings data-id="element-8" />
        <WhereToStart data-id="element-9" />
        <WhyWeCreated data-id="element-10" />
        <Testimonials data-id="element-11" />
        <FAQ data-id="element-12" />
        <Guarantee data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}